export default __webpack_public_path__ + "static/media/logo-transparent.0948570d.png";